module.exports = __webpack_public_path__ + "img/pic_location_ChanghuaCity.5aa605eb.png";